<script>
    import { createEventDispatcher, onDestroy } from 'svelte';
    import { fade, slide } from 'svelte/transition';

    const dispatch = createEventDispatcher();
    const close = () => dispatch('close');

    export let close_on_escape = false;
    export let close_on_background_click = false;
    export let open;

    export let delay = 50;
    export let out_duration = 1000;

    let modal;

    const previously_focused = typeof document !== 'undefined' && document.activeElement;

    if (previously_focused) {
        onDestroy(() => {
            previously_focused.focus();
        });
    }

    const handle_keydown = (e) => {
        if (close_on_escape && e.key === 'Escape') {
            close();
            return;
        }
    };

    const handle_background_click = (e) => {
        if (close_on_background_click && e.target === modal) {
            close();
            return;
        }
    };
</script>

<svelte:window on:keydown={handle_keydown} />

{#if open}
    <div class="bg">
        <div class="modal-background" on:click={handle_background_click} />

        <div
            class="modal"
            role="dialog"
            aria-modal="true"
            bind:this={modal}
            in:slide={{ duration: 1000, delay }}
            out:fade={{ duration: out_duration }}
        >
            <slot />
        </div>
    </div>
{/if}

<style>
    .modal-background {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
    }

    .modal {
        position: relative;
        width: 40rem;
        max-width: 100%;
        max-height: 100%;
        margin: 2rem auto;
        color: black;
        border-radius: 0.5rem;
        background: white;
        padding: 1em;
    }

    .bg {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.66);
    }

    * {
        box-sizing: border-box;
    }
</style>
